<div class="video-tool-wrapper" [ngStyle]="getContainerStyles()">
  <div
    [ngStyle]="getContainerStyles()"
    class="video-tool-wrapper"
    [class.emptySrc]="!entity.attributes.src"
    #videoContainerRef
  ></div>
</div>
